import { forwardRef } from "react";
import Upload from "./upload";
import { jsx as _jsx } from "react/jsx-runtime";
const InternalDragger = (_ref, ref) => {
  let {
    style,
    height,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(Upload, {
    ref: ref,
    ...restProps,
    type: "drag",
    style: {
      ...style,
      height
    }
  });
};
const Dragger = /*#__PURE__*/forwardRef(InternalDragger);
Dragger.displayName = "Dragger";
export default Dragger;